export const REFRESH_TOKEN = "refresh_token_igneous_tech";
export const JWT_TOKEN = "jwt_igneous_tech";
export const SELECTED_ORG = "org";
export const NEW_ORG_ID = "new_org_id";
export const USER_ORGS = "userOrgs";
export const PAGE_SIZE = "page_size";
export const LAST_ROUTE = "lastRoute";
export const LOGOUT = "logout_igneous_tech";
export const MOCK_PERMISSIONS = "mock_permissions";
